export default __webpack_public_path__ + "/datasets/domain_C1.csv";